import PropTypes from "prop-types";
import React from "react";
import { Redirect, Route } from "react-router-dom";

import { useAuth } from "./AuthContext";

export const PrivateRoute = ({ component: Component, hash, ...rest }) => {
	const auth = useAuth();
	return (
		<Route
			{...rest}
			render={({ location }) =>
				auth ? (
					<Component />
				) : (
					<Redirect
						to={{
							pathname: "/",
							search: window.location.search,
							state: { from: location },
							hash
						}}
					/>
				)
			}
		/>
	);
};

PrivateRoute.propTypes = {
	component: PropTypes.elementType.isRequired,
	hash: PropTypes.string
};

export const PublicOnlyRoute = ({ component: Component, hash, ...rest }) => {
	const auth = useAuth();
	return (
		<Route
			{...rest}
			render={({ location }) =>
				auth !== "cognito" ? (
					<Component />
				) : (
					<Redirect
						to={{
							pathname: "/orderHistory",
							search: window.location.search,
							state: { from: location },
							hash
						}}
					/>
				)
			}
		/>
	);
};

PublicOnlyRoute.propTypes = {
	component: PropTypes.elementType.isRequired
};
